import { ThemingConfig } from '@chakra-ui/react';

import fileUploadTileRecipe from './fileUploadTile';
import inputRecipe from './input';
import inputElementRecipe from './inputElement';

const basicRecipes: ThemingConfig['recipes'] = {
  input: inputRecipe,
  fileUploadTile: fileUploadTileRecipe,
  inputElement: inputElementRecipe,
};

export default basicRecipes;
